import {
  Card,
  CardContent,
  Typography,
  Grid,
  Button,
  CardMedia,
  createStyles,
  makeStyles,
  Theme,
  CardActions,
  List,
  ListItem,
  ListItemText,
  Tooltip,
  Switch,
  withStyles,
} from "@material-ui/core";

import { useVehicle } from "context";
import { useDeleteVehicle, useUpdateVehicle } from "rest";
import { InformationIcon } from "components";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    title: {
      marginBottom: 12,
      fontSize: 20,
    },
    description: {
      marginBottom: 12,
      fontSize: 14,
    },
    media: {
      width: 200,
      height: 140,
    },
    mediaX: {
      width: 200,
      height: 140,
    },
    details: {
      display: "flex",
    },
    content: {
      padding: "16px !important",
      flex: "1 0 auto",
    },
    disabledDiv: {
      pointerEvents: "none",
      opacity: "0.7",
      transition: "0.5s",
      maxWidth: 345,
    },
    root: {
      maxWidth: 345,
    },
  })
);

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: "#f5f5f9",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9",
  },
}))(Tooltip);

// const RedSwitch = withStyles({
//   switchBase: {
//     color: "#FF0000 !important",
//   },
//   checked: { color: "#54AE36 !important" },
//   track: {},
// })(Switch);

const RedSwitch = withStyles({
  switchBase: {
    color: "#FF0000",
  },
  checked: {},
  track: {},
})(Switch);

export const VehicleCard = ({ openVehicleForm }) => {
  const classes = useStyles();

  const { vehicles, card1, card2, card3, prev, setChecked, setSavedVehicle, setCheckedE } = useVehicle();

  const { mutate: deleteVehicle } = useDeleteVehicle({
    onSuccess: () => {
      setChecked(true);
      setSavedVehicle(false);
      setTimeout(() => {
        setChecked(false);
      }, 5000);
    },
    onError: () => {
      setCheckedE(true);
      setTimeout(() => {
        setCheckedE(false);
      }, 5000);
    },
  });

  const { mutate: updateVehicle } = useUpdateVehicle({
    onSuccess: () => {
      setSavedVehicle(false);
      setChecked(true);
      setTimeout(() => {
        setChecked(false);
      }, 5000);
    },
    onError: () => {
      setCheckedE(true);
      setTimeout(() => {
        setCheckedE(false);
      }, 5000);
    },
  });

  const handleVehicleActive = (e: any) => {
    let updateVehicleObject = {
      lengthInM: vehicles.lengthInM.replace(",", "."),
      numberplate: vehicles.numberplate.toString(),
      pendantLengthInM: vehicles.pendant.lengthInM.replace(",", "."),
      pendantNumberplate: vehicles.pendant.numberplate.toString(),
      isPendantActive: vehicles.pendant.isPendantActive,
      carLengthInM: vehicles.car.lengthInM.replace(",", "."),
      carNumberplate: vehicles.car.numberplate.toString(),
      isCarActive: vehicles.car.isCarActive,
      isVehicleActive: e.target.checked,
      hasMoto: vehicles.hasMoto,
      hasBike: vehicles.hasBike,
      hasTent: vehicles.hasTent,
    };

    updateVehicle(updateVehicleObject);
  };

  const removeVehicle = () => {
    // deleteVehicle({});

    let updateVehicleObject = {
      lengthInM: "",
      numberplate: "",
      pendantLengthInM: vehicles.pendant.lengthInM.replace(",", "."),
      pendantNumberplate: vehicles.pendant.numberplate.toString(),
      isPendantActive: vehicles.pendant.isPendantActive,
      carLengthInM: vehicles.car.lengthInM.replace(",", "."),
      carNumberplate: vehicles.car.numberplate.toString(),
      isCarActive: vehicles.car.isCarActive,
      isVehicleActive: false,
      hasMoto: vehicles.hasMoto,
      hasBike: vehicles.hasBike,
      hasTent: vehicles.hasTent,
    };

    updateVehicle(updateVehicleObject);
  };

  return (
    <Card elevation={card1} className={card2 === 5 || card3 === 5 ? classes.disabledDiv : classes.root}>
      <CardContent className={card1 === 5 ? classes.disabledDiv : ""}>
        <Typography style={{ fontWeight: "bold" }} variant="h5" component="h2" color="primary">
          Wohnmobil
        </Typography>
      </CardContent>

      <CardMedia
        // className={classes.mediaX}
        component="img"
        alt="Vehicle"
        height="200"
        image="/assets/images/womo.png"
        title="Vehicle"
      />
      <CardContent className={card1 === 5 ? classes.disabledDiv : ""}>
        <Grid
          container
          spacing={2}
          style={prev?.hasVehicle ? { paddingBottom: "12px" } : { paddingBottom: "0px" }}
        >
          <Grid item md={6}>
            <Button
              onClick={openVehicleForm}
              variant="contained"
              disableElevation
              color="primary"
              style={{ width: "100%" }}
            >
              Bearbeiten
            </Button>
          </Grid>
          <Grid item md={6}>
            <Button
              disabled={!prev?.hasVehicle}
              onClick={removeVehicle}
              variant="contained"
              disableElevation
              style={{ width: "100%" }}
            >
              Löschen
            </Button>
          </Grid>
        </Grid>
        {prev?.hasVehicle && (
          <Grid container spacing={4} className={card1 === 5 ? classes.disabledDiv : ""}>
            <List aria-label="Information">
              <ListItem style={{ paddingTop: "8px", paddingBottom: "0px" }}>
                <Typography variant="h6" component="h2" color="primary">
                  Kennzeichen:
                </Typography>
              </ListItem>
              <ListItem style={{ paddingTop: "0px", paddingBottom: "0px" }}>
                <Typography variant="h6" component="h2" color="textPrimary">
                  {prev?.numberplate}
                </Typography>
              </ListItem>
              <ListItem style={{ paddingTop: "0px", paddingBottom: "0px" }}>
                <Typography variant="h6" component="h2" color="primary">
                  Länge in Meter:
                </Typography>
              </ListItem>
              <ListItem style={{ paddingTop: "0px", paddingBottom: "0px" }}>
                <Typography variant="h6" component="h2" color="textPrimary" style={{ paddingRight: "75px" }}>
                  {`${prev?.lengthInM} Meter`}
                </Typography>
                <RedSwitch
                  checked={prev?.isVehicleActive}
                  onChange={(e: any) => handleVehicleActive(e)}
                  id={"isVehicleActive"}
                  name="checkedB"
                  color="primary"
                  // style={{
                  //   marginLeft: "75px",
                  // }}
                  // color="primary"
                />
                <HtmlTooltip
                  title={
                    <>
                      <span>
                        <p>Bitte wählen Sie ihre Fahrzeuge für die Reservierung</p>
                      </span>
                    </>
                  }
                >
                  <InformationIcon style={{ fill: "green", marginLeft: "10px" }} />
                </HtmlTooltip>
              </ListItem>
            </List>
          </Grid>
        )}
      </CardContent>
    </Card>
  );

  // return (
  //   <Card elevation={card1} className={card2 === 5 ? classes.disabledDiv : ""}>
  //     <div className={classes.details}>
  //       <CardContent className={classes.content} style={{ textAlign: "right" }}>
  //         <Typography className={classes.title} color="primary" gutterBottom>
  //           {prev?.numberplate}
  //         </Typography>
  //         <Typography className={classes.description} color="primary" gutterBottom>
  //           {prev?.lengthInM}
  //         </Typography>
  //         <Grid container spacing={2} className={card1 === 5 ? classes.disabledDiv : ""}>
  //           <Grid item md={6}>
  //             <Button
  //               onClick={openVehicleForm}
  //               size="small"
  //               variant="contained"
  //               disableElevation
  //               color="primary"
  //               style={{ width: "100%" }}
  //             >
  //               Bearbeiten
  //             </Button>
  //           </Grid>
  //           <Grid item md={6}>
  //             <Button
  //               onClick={removeVehicle}
  //               size="small"
  //               variant="contained"
  //               disableElevation
  //               style={{ width: "100%" }}
  //             >
  //               Löschen
  //             </Button>
  //           </Grid>
  //         </Grid>
  //       </CardContent>
  //       <CardMedia className={classes.media} image="/assets/images/mt.jpg" title="Vehicle" />
  //     </div>
  //   </Card>
  // );
};
